import React, { memo } from 'react';
import { ArrowUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const FilesEmpty: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col items-center justify-center relative"
      style={{ height: 'calc(100vh - 300px)' }}
    >
      <div className="flex flex-col items-center space-y-8">
        <div className="animate-float">
          <ArrowUp
            className="text-gray-400 dark:text-gray-500"
            size={48}
            strokeWidth={1.5}
          />
        </div>

        <div className="flex flex-col items-center text-center space-y-3 max-w-xl">
          <h2 className="text-3xl font-light text-gray-700 dark:text-gray-300 tracking-tight">
            {t('library.empty.title')}
          </h2>

          <p className="text-base text-gray-500 dark:text-gray-400 leading-relaxed px-4">
            {t('library.empty.description')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default memo(FilesEmpty);
